import React, { FC } from 'react';

import { Box, BoxProps } from '@mantine/core';

import cx from './styles.module.scss';

const SimpleButtonGroup: FC<
    {
        children: React.ReactNode;
    } & BoxProps
> = ({ children, ...props }) => (
    <Box {...props} className={[props.className, cx.buttonGroup].join(' ')}>
        {children}
    </Box>
);

export { SimpleButtonGroup };
